export const APP_TOGGLE_USER_MENU = 'APP_TOGGLE_USER_MENU';
export const APP_TOGGLE_LANGUAGE = 'APP_TOGGLE_LANGUAGE';
